import useStore from './useStore';

const useRouterStore = () => {
    const { routerStore } = useStore();

    return routerStore;
};

export default useRouterStore;
